export default __webpack_public_path__ + "static/media/4.4d17b313.jpg";